const CHIPS_BASE_OFFSET = 40;
const CONTROL_BUTTON_WIDTH = 37;

/**
 * Chips in the list view must not overlap the row action buttons,
 * so they are inset from the right by the width of the buttons which are rendered.
 * Mobile view renders no action buttons at all, so chips take the whole row width.
 * @param {Object} params
 * @returns {Object} inline styles for the chips wrapper
 */
export default function getListViewChipsStyles({
  isListViewMode = false,
  isMobileView = false,
  isMainApp = false,
  allowAssetSharing = false,
  uploadFiles = false,
  allowDuplicateAsset = false,
  downloadFiles = false,
  enableEditor = false,
  isLightboardsView = false,
  isTrashed = false,
  removeFiles = false,
} = {}) {
  if (!isListViewMode || isMobileView) return {};

  let right = CHIPS_BASE_OFFSET;
  if (allowAssetSharing) right += CONTROL_BUTTON_WIDTH;
  if (uploadFiles) right += CONTROL_BUTTON_WIDTH;
  if (allowDuplicateAsset) right += CONTROL_BUTTON_WIDTH;
  if (downloadFiles) right += CONTROL_BUTTON_WIDTH;
  if (enableEditor) right += CONTROL_BUTTON_WIDTH;
  if (isLightboardsView) right += CONTROL_BUTTON_WIDTH;
  if (isMainApp && isTrashed) right += CONTROL_BUTTON_WIDTH * 2;
  if (removeFiles) right += CONTROL_BUTTON_WIDTH;

  return { right };
}
